<div class="layout-wrapper"  (click)="onLayoutClick()"
     [ngClass]="{'layout-static': app.menuMode === 'static',
                'layout-overlay': app.menuMode === 'overlay',
                'layout-slim': app.menuMode === 'slim',
                'layout-horizontal': app.menuMode === 'horizontal',
                'layout-sidebar': app.menuMode === 'sidebar',
                'layout-sidebar-static': app.menuMode === 'sidebar' && sidebarStatic,
                'layout-overlay-active': overlayMenuActive,
                'layout-mobile-active': staticMenuMobileActive,
                'layout-static-inactive': staticMenuDesktopInactive && app.menuMode === 'static',
                 'p-ripple-disabled': !app.ripple}">

    <div class="layout-main">

        <app-topbar *ngIf="isMobile() || isOverlay() || isHorizontal()"></app-topbar>

        <app-menu *ngIf="!isMobile() && (isStatic() || isSlim() || isSidebar())"></app-menu>

        <app-breadcrumb></app-breadcrumb>

        <div class="message-notifier-container">
            <p-messages class="message-notifier" key="msg" [escape]="false"></p-messages>
        </div>


        <p-toast class="toast-notifier" key="tst" [style]="{marginTop: '70px'}"
        [preventOpenDuplicates]="true"></p-toast>


        <div class="layout-main-content">
            <div class="is-loading-modal-background" *ngIf="cache.isLoading | async"></div>
            <p-progressSpinner class="is-loading-spinner" styleClass="custom-spinner" *ngIf="cache.isLoading | async"></p-progressSpinner>
            <router-outlet></router-outlet>
        </div>

        <app-footer></app-footer>
    </div>

    <app-rightmenu></app-rightmenu>

    <!-- <app-config></app-config> -->

</div>
